// Localization file, segregated based on game name.
// *** NOTE ***
// Those general info are used across different games
// should always maintained in general object to prevent
// double info. Please refer en.js as full example.

const th = {
  general: {
    wallet: "เครดิตการเดิมพัน",
    menulogout: "HOME",// "ออกจากระบบ",
    goodroad: "Dragon Alert",
    menufavourite: "Favourite",
    favouritegame: "Favourite Game",
    availablegame: "Available Game",
    confirm: "Confirm",
    menusfx: "SFX",
    menuon: "เปิด",
    menuoff: "ปิด",
    menurules: "กฎ",
    menuresult: "ผลลัพธ์",
    menustatement: "รายงานการเงิน",
    menunotification: "ประกาศ",
    menuviewhistory: "ดูประวัติ",
    menufullscreen: "เต็มจอ",
    marketclosed: "ตลาดปิด",
    menutrend: "เทรนด์",
    menusimple: "ง่าย",
    menunormal: "ปกติ",

    draw_no: "รอบ No.",
    rebet: "เดิมพันซ้ำ",
    no_more_bet: "ปิดรับเดิมพันเพิ่มเติม",
    sum: "รวม",
    next_draw: "การจับหมายเลขถัดไป",
    last_bets_for: "เดิมพันครั้งสุดท้ายสำหรับ",
    bet_total: "เดิมพันทั้งหมด",
    no_bets_last_round: "ไม่มีการเดิมพันรอบสุดท้าย",
    max: "สูงสุด",
    payout: "การจ่ายเงิน",
    min_to: "ต่ำสุด",
    max_to: "สูงสุด",
    cancel: "ยกเลิก",
    bet: "วางเดิมพัน",
    ref: "หมายเลขอ้างอิง",
    gap: "แก็ป",

    sum_bs_short: "รวมใหญ่/เล็ก",
    sum_oe_short: "รวมคี่/คู่",
    Big: "ใหญ่",
    Small: "เล็ก",
    Even: "คู่",
    Odd: "คี่",
    Dice: "ลูกเต๋า",
    Triple: "การทริปเปิล",
    // High: "ตอง",
    // Low: "ต่ำ",
    Black: "ดำ",
    Red: "แดง",
    Joker: "โจ๊กเกอร์",

    //for history TabPane
    Result: "ผลลัพธ์",
    Sum_Player: "ผู้เล่นรวม",
    Sum_Banker: "เจ้ามือรวม",
    CARD_HISTORY: "ประวัติไพ่",
    STATISTICS: "สถิติ",
    RED_BLACK: "สแดง/ดำ",
    HI_LO: "บน/ล่าง",
    Player: "ผู้เล่น",
    Tie: "เสมอ",
    Banker: "เจ้ามือ",

    PLACE_TICKET: "เดิมพัน",
    PLACE_FAIL: "เดิมพันล้มเหลว!",
    PLACE_SUCCESS: "เดิมพันสำเร็จ!",
    ERROR_MIN_TO: "ขออภัย ไม่สามารถวางเดิมพันน้อยกว่าจำนวนเดิมพันต่ำสุดได้!",
    ERROR_MAX_TO: "ขออภัย ไม่สามารถวางเดิมพันมากกว่าจำนวนเดิมพันสูงสุดได้!",
    ERROR_MAX_DR:
      "ขออภัย ท่านวางเดิมพันเกินจำนวนสูงสุดต่อรอบการจับหมายเลขแล้ว!",
    ERROR_MAX_BTDR:
      "ขออภัย ประเภทเดิมพันนี้เกินจำนวนสูงสุดต่อรอบการจับหมายเลขแล้ว!",
    ERROR_NMB: "ขออภัย ปิดรับเดิมพันเพิ่มเติมแล้ว",
    ERROR_GAME_UA:
      "ไม่สามารถวางเดิมพันได้ในขณะนี้ โปรดติดต่อเราสำหรับรายละเอียดเพิ่มเติม ขอบคุณค่ะ",
    ERROR_REBET_DONE:
      "ขออภัย ท่านกดเดิมพันซ้ำสำหรับบิลเดิมพันก่อนหน้านี้เรียบร้อยแล้ว",
    ERROR_TO: "ขออภัย กรุณากรอกจำนวนเงินเดิมพันใหม่อีกครั้ง",
    ERROR_XAMOUNT: "ขออภัย ยอดเงินคงเหลือของท่านไม่เพียงพอสำหรับวางเดิมพัน!",
    ERROR_206: "ถึงยอดชนะที่จำกัดไว้! โปรดติดต่ออัพไลน์ของคุณ ขอบคุณค่ะ ",
    ERROR_207: "ถึงยอดเสียที่จำกัดไว้! โปรดติดต่ออัพไลน์ของคุณ ขอบคุณค่ะ",
    ERROR_208: "บัญชีถูกระงับ! โปรดติดต่ออัพไลน์ของคุณ ขอบคุณค่ะ",
    ERROR_209: "บัญชีไม่ได้เปิดใช้งาน! โปรดติดต่ออัพไลน์ของคุณ ขอบคุณค่ะ",
  },
 
  tai_xiu: {
    dicehistory: "ประวัติลูกเต๋า",
    o1group: "ใหญ่/ตอง/เล็ก",
    o2group: "ใหญ่/ตอง/เล็ก",
    o3group: "ใหญ่/ตอง/เล็ก",
    o4group: "คี่/คู่",
    o5group: "คี่/คู่",

    o11group: "ตัวเลขเฉพาะ",
    o21group: "ตัวเลขเฉพาะ",
    o31group: "ตัวเลขเฉพาะ",
    o41group: "ตัวเลขเฉพาะ",
    o51group: "ตัวเลขเฉพาะ",
    o61group: "ตัวเลขเฉพาะ",
    o104group: "ผลรวมเฉพาะ",
    o105group: "ผลรวมเฉพาะ",
    o106group: "ผลรวมเฉพาะ",
    o107group: "ผลรวมเฉพาะ",
    o108group: "ผลรวมเฉพาะ",
    o109group: "ผลรวมเฉพาะ",
    o110group: "ผลรวมเฉพาะ",
    o111group: "ผลรวมเฉพาะ",
    o112group: "ผลรวมเฉพาะ",
    o113group: "ผลรวมเฉพาะ",
    o114group: "ผลรวมเฉพาะ",
    o115group: "ผลรวมเฉพาะ",
    o116group: "ผลรวมเฉพาะ",
    o117group: "ผลรวมเฉพาะ",

    o1: "ใหญ่",
    o1_trend: "ใหญ่",
    o2: "เล็ก",
    o2_trend: "เล็ก",
    o3: "ตอง",
    o3_trend: "AT",
    o4: "คี่",
    o4_trend: "คี่",
    o5: "คู่",
    o5_trend: "คู่",

    o11: "ลูกเต๋า 1",
    o12: "2x ลูกเต๋า 1",
    o13: "3x ลูกเต๋า 1",
    o21: "ลูกเต๋า 2",
    o22: "2x ลูกเต๋า 2",
    o23: "3x ลูกเต๋า 2",
    o31: "ลูกเต๋า 3",
    o32: "2x ลูกเต๋า 3",
    o33: "3x ลูกเต๋า 3",
    o41: "ลูกเต๋า 4",
    o42: "2x ลูกเต๋า 4",
    o43: "3x ลูกเต๋า 4",
    o51: "ลูกเต๋า 5",
    o52: "2x ลูกเต๋า 5",
    o53: "3x ลูกเต๋า 5",
    o61: "ลูกเต๋า 6",
    o62: "2x ลูกเต๋า 6",
    o63: "3x ลูกเต๋า 6",

    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "10",
    o110_trend: "10",
    o111: "11",
    o111_trend: "11",
    o112: "12",
    o112_trend: "12",
    o113: "13",
    o113_trend: "13",
    o114: "14",
    o114_trend: "14",
    o115: "15",
    o115_trend: "15",
    o116: "16",
    o116_trend: "16",
    o117: "17",
    o117_trend: "17",

    "1_dice": "1 ลูกเต๋า",
    "2_dice": "2 ลูกเต๋า",
    "3_dice": "3 ลูกเต๋า",
  },

  hi_lo: {
    o1: "บน",
    o1_trend: "บน",
    o2: "ล่าง",
    o2_trend: "ล่าง",
    o3: "แดง",
    o3_trend: "แดง",
    o4: "ดำ",
    o4_trend: "ดำ",
    o5: "ช่วง 2-9",
    o5_trend: "2-9",
    o6: "ช่วง JQKA",
    o6_trend: "JQKA",
    o7: "ช่วง KA",
    o7_trend: "KA",
    o101: "ไพ่ A",
    o101_trend: "A",
    o102: "ไพ่ 2",
    o102_trend: "2",
    o103: "ไพ่ 3",
    o103_trend: "3",
    o104: "ไพ่ 4",
    o104_trend: "4",
    o105: "ไพ่ 5",
    o105_trend: "5",
    o106: "ไพ่ 6",
    o106_trend: "6",
    o107: "ไพ่ 7",
    o107_trend: "7",
    o108: "ไพ่ 8",
    o108_trend: "8",
    o109: "ไพ่ 9",
    o109_trend: "9",
    o110: "ไพ่ J",
    o110_trend: "J",
    o111: "ไพ่ Q",
    o111_trend: "Q",
    o112: "ไพ่ K",
    o112_trend: "K",
    o113: "โจ๊กเกอร์",
    o113_trend: "JK",

    //for new-bet-lot
    o1group: "บน/ล่าง",
    o2group: "บน/ล่าง",
    o3group: "แดง/ดำ",
    o4group: "แดง/ดำ",
    o5group: "ช่วงเฉพาะ",
    o6group: "ช่วงเฉพาะ",
    o7group: "ช่วงเฉพาะ",
    o101group: "ช่วงเฉพาะ",
    o102group: "ช่วงเฉพาะ",
    o103group: "ช่วงเฉพาะ",
    o104group: "ช่วงเฉพาะ",
    o105group: "ช่วงเฉพาะ",
    o106group: "ช่วงเฉพาะ",
    o107group: "ช่วงเฉพาะ",
    o108group: "ช่วงเฉพาะ",
    o109group: "ช่วงเฉพาะ",
    o110group: "ช่วงเฉพาะ",
    o111group: "ช่วงเฉพาะ",
    o112group: "ช่วงเฉพาะ",
    o113group: "ช่วงเฉพาะ",
  },

  domino: {
    main: "หลัก",
    result: "หลัก",
    o1: "ผู้เล่น",
    o1_trend: "ผู้เล่น",
    o2: "เท่ากัน",
    o2_trend: "เท่ากัน",
    o3: "เจ้ามือ",
    o3_trend: "เจ้ามือ",
    o4: "ใหญ่",
    o4_trend: "ใหญ่",
    o5: "เล็ก",
    o5_trend: "เล็ก",
    o6: "คี่",
    o6_trend: "คี่",
    o7: "คู่",
    o7_trend: "คู่",
    o8: "ใหญ่",
    o8_trend: "ใหญ่",
    o9: "เล็ก",
    o9_trend: "เล็ก",
    o10: "คี่",
    o10_trend: "คี่",
    o11: "คู่",
    o11_trend: "คู่",
    o12_trend: "/",

    //for new-bet-lot
    o1group: "ผู้เล่น/เท่ากัน/เจ้ามือ",
    o2group: "ผู้เล่น/เท่ากัน/เจ้ามือ",
    o3group: "ผู้เล่น/เท่ากัน/เจ้ามือ",
    o4group: "ผู้เล่นใหญ่/เล็ก",
    o5group: "ผู้เล่นใหญ่/เล็ก",
    o6group: "ผู้เล่นคี่/คู่",
    o7group: "ผู้เล่นคี่/คู่",
    o8group: "เจ้ามือใหญ่/เล็ก",
    o9group: "เจ้ามือใหญ่/เล็ก",
    o10group: "เเจ้ามือคี่/คู่",
    o11group: "เเจ้ามือคี่/คู่",

    P_BS: "P ใหญ่/เล็ก",
    P_OE: "P คี่/คู่",
    B_BS: "B ใหญ่/เล็ก",
    B_OE: "B คี่/คู่",

    PLAYER: "ผู้เล่น",
    BANKER: "เจ้ามือ",
    PLAYER_WIN: "ผู้เล่นชนะ",
    BANKER_WIN: "เจ้ามือชนะ",
    TIE: "เท่ากัน",

    PLAYER_BIG: "ผู้เล่นใหญ่",
    PLAYER_SMALL: "ผู้เล่นเล็ก",
    PLAYER_ODD: "ผู้เล่นคี่",
    PLAYER_EVEN: "ผู้เล่นคู่",

    BANKER_BIG: "เจ้ามือใหญ่",
    BANKER_SMALL: "เจ้ามือเล็ก",
    BANKER_ODD: "เจ้ามือคี่",
    BANKER_EVEN: "เจ้ามือคู่",
  },

  fantan: {
    o1group: "Fan",
    o2group: "Ssh",
    o3group: "Kwok",
    o4group: "Nim",
    o5group: "Nga",
    o6group: "คี่/คู่",
    o7group: "เท่ากัน",
    total: "รวมทั้งหมด",
    odd: "คี่",
    even: "คู่",
    fan: "Fan",
    ssh: "Ssh",
    kwok: "Kwok",
    nga: "Nga",
    nim: "Nim",
    fan1: "Fan1",
    fan2: "Fan2",
    fan3: "Fan3",
    fan4: "Fan4",
    odd_trend: "คี่",
    even_trend: "คู่",
    result: "ผลลัพธ์",
    history: "ประวัติศาสตร์",
    OE: "คี่/คู่",
  },

  maxracing: {
    o1: "C(th)",
    o1_trend: "C(th)",
    o2: "Big(th)",
    o2_trend: "B(th)",
    o3: "Small(th)",
    o3_trend: "S(th)",
    o4: "Odd(th)",
    o4_trend: "O(th)",
    o5: "Even(th)",
    o5_trend: "E(th)",
    o6: "Big(th)",
    o6_trend: "B(th)",
    o7: "Small(th)",
    o7_trend: "S(th)",
    o8: "Odd(th)",
    o8_trend: "O(th)",
    o9: "Even(th)",
    o9_trend: "E(th)",
    o10: "G1(th)",
    o10_trend: "G1(th)",
    o11: "G2(th)",
    o11_trend: "G2(th)",
    o12: "G3(th)",
    o12_trend: "G3(th)",
    o13: "G4(th)",
    o13_trend: "G5(th)",
    o14: "G5(th)",
    o14_trend: "G5(th)",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",

    Champion: "Champion(th)",
    C_BS: "C B/S(th)",
    C_OE: "C O/E(th)",
    S_BS: "S B/S(th)",
    S_OE: "S O/E(th)",
    Group: "Group(th)",
    Place_champ: "Place Champion(th)",
    Place_sum_champ: "Place Sum Champion(th)",
    Runner_up: "Runner-up(th)",
    Race_result: "Race Result(th)",
  },
};

export default th;
